//export const baseurladdress = "http://localhost:7500/" ;
 export const baseurladdress = "https://ddcpharmacy.com/api2/" ;